"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useSelection", {
    enumerable: true,
    get: function() {
        return _useSelection.useSelection;
    }
});
const _useSelection = require("./useSelection");
